module.exports = __webpack_public_path__ + "assets/img/产品图.35816126.png";